module.exports = __webpack_public_path__ + "media/images/web_suite/icon_android-0a0ca2833c3eb642b1f9b96db5d24ac5.png";